import { Outlet } from "react-router-dom";
import Channels from "./Channels";
import ChannelDetails from "./ChannelDetails";

export const adminChannelsRoutes = [
  {
    path: "channels",
    element: Outlet,
    children: [
      {
        path: "",
        element: Channels,
      },
      {
        path: ":channelConnectionID",
        element: ChannelDetails,
      },
    ],
  },
];
